import React from 'react';
import SEO from '../components/SEO';
import JsonLd, { organizationSchema, localBusinessSchema, websiteSchema } from '../components/JsonLd';
import HeroSection from '../components/HeroSection';
import JustImagineSection from '../components/JustImagineSection';
import JourneySection from '../components/JourneySection';
import SolutionsSection from '../components/SolutionsSection';
import DataSection from '../components/DataSection';
import VideoShowcase from '../components/VideoShowcase';
import ClientLogos from '../components/ClientLogos';
import IntegrationsScroller from '../components/IntegrationsScroller';
import TeamSection from '../components/TeamSection';
import Testimonials from '../components/Testimonials';
import Resources from '../components/Resources';
import FAQSection from '../components/FAQSection';
import { homeFaqs } from '../data/faqData';
import ContactForm from '../components/ContactForm';

const HomePage = () => {
  return (
    <>
      <SEO url="https://imprint-mis.co.uk/" />
      <JsonLd data={organizationSchema} />
      <JsonLd data={localBusinessSchema} />
      <JsonLd data={websiteSchema} />
      <HeroSection />
      <JustImagineSection />
      <JourneySection />
      <SolutionsSection />
      <DataSection />
      <VideoShowcase />
      <ClientLogos />
      <IntegrationsScroller />
      <TeamSection />
      <Testimonials />
      <Resources />
      <FAQSection
        id="faq"
        eyebrow="Frequently Asked Questions"
        title="Everything you need to know about"
        highlight="Print MIS"
        subtitle="Straight answers from the technical team — no sales gloss."
        faqs={homeFaqs}
      />
      <ContactForm />
    </>
  );
};

export default HomePage;
